import $ from 'jquery';

const Variations = {
  updateGrossWeight() {
    const netWeight = parseFloat($(`#variation_weight`).val()),
      boxWeight = parseFloat($(`#variation_box_weight`).val());

    $(`#variation_gross_weight`).val(netWeight + boxWeight);
  },

  bindToWeightEdit() {
    $(`#variation_weight`).change((e) => {
      e.preventDefault();
      this.updateGrossWeight();
    });
  },

  bindToBoxWeightEdit() {
    $(`#variation_box_weight`).change((e) => {
      e.preventDefault();
      this.updateGrossWeight();
    });
  },

  bindToPage() {
    this.bindToWeightEdit();
    this.bindToBoxWeightEdit();
    this.updateGrossWeight();
  },

  init() {
    if ($(`.variations.edit`).length === 0) {
      return;
    }
    this.bindToPage();
  },
};

export default Variations;
